module.exports = require("./pt-PT.js");